import {
  Grid,
  makeStyles,
  CircularProgress,
  Typography,
  Divider,
} from '@material-ui/core';
import React from 'react';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import i18n from 'i18n';
import palette from 'theme/palette';
import CheckIcon from '@material-ui/icons/CheckCircle';
import styles from './styles';

interface Props {
  urlConnectionRemoteApp: string;
  urlChromeExtension: string;
}

const useStyles = makeStyles(styles);

const SimulateConnectSky = ({
  urlConnectionRemoteApp,
  urlChromeExtension,
}: Props) => {
  const [url, setUrl] = React.useState<string>();
  const [step, setStep] = React.useState(0);
  const [openExtension, setOpenExtension] = React.useState(false);
  const classes = useStyles();

  React.useEffect(() => {
    if (urlConnectionRemoteApp) {
      setUrl(urlConnectionRemoteApp);
    }
    setTimeout(() => {
      setStep(1);
    }, 12000);
  }, [urlConnectionRemoteApp, openExtension]);

  const handleOpenChrome = () => {
    setUrl('');
    setOpenExtension(!openExtension);
  };

  return (
    <>
      {step === 0 ? (
        <Grid>
          {url && (
            <iframe
              src={url}
              style={{
                display: 'none',
              }}
              title="plugin autoSky"
              id="plugin_iframe"
            />
          )}
          <Grid>
            <img
              className={classes.loadingAppLogo}
              src="/images/AutoSkyLogoColorido.svg"
              alt="skyone logo"
              height={40}
              style={{
                marginTop: 30,
              }}
            />
            <Grid
              className={classes.loadingContainer}
              style={{
                marginTop: 60,
              }}
            >
              <CircularProgress className={classes.loadingAppIcon} />
              <Typography className={classes.connectSkyTitle}>
                {i18n.t('APPLICATIONS_PAGE.CONNECTED_KEY_SIMULATE_KEY')}
              </Typography>
              <Divider
                className={classes.divider}
                style={{
                  background: palette.black,
                  width: '80%',
                  height: 1,
                  marginBottom: 30,
                }}
              />
              <Typography className={classes.loadingAppText}>
                {i18n.t(
                  'APPLICATIONS_PAGE.CONNECTED_KEY_SIMULATE_CONTENT_HELP_KEY'
                )}{' '}
                <a
                  href={urlChromeExtension}
                  className={classes.spanClickHere}
                  onClick={handleOpenChrome}
                >
                  {i18n.t('APPLICATIONS_PAGE.EXECUTE_KEY')}
                </a>
              </Typography>
              <Typography className={classes.loadingAppText}>
                {i18n.t('APPLICATIONS_PAGE.FIRST_ACCESS_KEY')}{' '}
                <a
                  className={classes.spanClickHere}
                  href="https://skyoneautoskyplugin.s3.amazonaws.com/pacotes/ultima-versao/setup-apl.msi"
                >
                  {i18n.t('APPLICATIONS_PAGE.EXECUTE_PLUGIN_KEY')}
                </a>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          className={classes.loadingContainer}
          style={{
            marginTop: 250,
          }}
        >
          <img
            className={classes.loadingAppLogo}
            src="/images/AutoSkyLogoColorido.svg"
            alt="skyone logo"
          />
          <CheckIcon
            className={classes.iconSuccess}
            style={{
              fontSize: 80,
            }}
          />
          <Typography className={classes.loadingAppText}>
            {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_FINISH_KEY')}
          </Typography>
          <Typography className={classes.loadingAppText}>
            {i18n.t('APPLICATIONS_PAGE.WAIT_EXECUTE_APP_KEY')}
          </Typography>
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = ({
  clients: { urlConnectionRemoteApp, urlChromeExtension },
}: ApplicationState) => ({
  urlConnectionRemoteApp,
  urlChromeExtension,
});

export default connect(mapStateToProps, {})(SimulateConnectSky);
